/**
 * Title puzzles — names of well-known songs, films, novels, plays the
 * 70-95+ audience grew up with. Public titles are not protected expression;
 * we use just the title, never copy lyrics or scripts.
 */
export const TITLES = [
  'GONE WITH THE WIND',
  'CASABLANCA',
  'CITIZEN KANE',
  'THE WIZARD OF OZ',
  'IT IS A WONDERFUL LIFE',
  'SINGIN IN THE RAIN',
  'THE SOUND OF MUSIC',
  'MARY POPPINS',
  'WEST SIDE STORY',
  'THE KING AND I',
  'MY FAIR LADY',
  'SOUTH PACIFIC',
  'OKLAHOMA',
  'GUYS AND DOLLS',
  'AN AMERICAN IN PARIS',
  'A STREETCAR NAMED DESIRE',
  'TO KILL A MOCKINGBIRD',
  'BREAKFAST AT TIFFANYS',
  'ROMAN HOLIDAY',
  'REAR WINDOW',
  'NORTH BY NORTHWEST',
  'VERTIGO',
  'THE BIRDS',
  'PSYCHO',
  'SOME LIKE IT HOT',
  'THE APARTMENT',
  'SUNSET BOULEVARD',
  'ON THE WATERFRONT',
  'TWELVE ANGRY MEN',
  'HIGH NOON',
  'THE QUIET MAN',
  'THE MAN WHO SHOT LIBERTY VALANCE',
  'BEN HUR',
  'THE TEN COMMANDMENTS',
  'LAWRENCE OF ARABIA',
  'DOCTOR ZHIVAGO',
  'THE BRIDGE ON THE RIVER KWAI',
  'BRIDGE OVER TROUBLED WATER',
  'WHITE CHRISTMAS',
  'BLUE MOON',
  'MOON RIVER',
  'OVER THE RAINBOW',
  'YESTERDAY',
  'YOU ARE MY SUNSHINE',
  'AMAZING GRACE',
  'WHAT A WONDERFUL WORLD',
  'STAND BY ME',
  'UNCHAINED MELODY',
  'AS TIME GOES BY',
  'STARDUST',
  'MY WAY',
  'NEW YORK NEW YORK',
  'COME FLY WITH ME',
  'FLY ME TO THE MOON',
  'STRANGERS IN THE NIGHT',
  'THE WAY WE WERE',
  'PEOPLE WHO NEED PEOPLE',
  'PRIDE AND PREJUDICE',
  'WUTHERING HEIGHTS',
  'JANE EYRE',
  'GREAT EXPECTATIONS',
  'A TALE OF TWO CITIES',
  'OLIVER TWIST',
  'DAVID COPPERFIELD',
  'TREASURE ISLAND',
  'TOM SAWYER',
  'HUCKLEBERRY FINN',
  'LITTLE WOMEN',
  'ANNE OF GREEN GABLES',
  'THE OLD MAN AND THE SEA',
  'OF MICE AND MEN',
  'THE GRAPES OF WRATH',
  'EAST OF EDEN',
  'A FAREWELL TO ARMS',
  'FOR WHOM THE BELL TOLLS',
  'THE SUN ALSO RISES',
  'A MIDSUMMER NIGHTS DREAM',
  'THE TAMING OF THE SHREW',
  'MUCH ADO ABOUT NOTHING',
  'ROMEO AND JULIET',
  'A CHRISTMAS CAROL',
  'WAR AND PEACE',
  'ANNA KARENINA',
  'LITTLE HOUSE ON THE PRAIRIE',
] as const;
